// extracted by mini-css-extract-plugin
export default {"revenueBox":"ContractApplication_revenueBox__oYuIV","qrCode":"ContractApplication_qrCode__y2LbA","lineLink":"ContractApplication_lineLink__tbCEw"};